import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { RedeEspecialAcordoDialogBase } from '../rede-especial-dialog-base';
import { TipoAtualizacaoEnum } from '../rede-especial-enuns';
import { AcordoRedeEspecialViewModel } from '../rede-especial.interface';
import { RedeEspecialService } from '../rede-especial.service';

@Component({
  selector: 'app-aceitar-acordo-dialog',
  templateUrl: './aceitar-acordo-dialog.component.html',
  styleUrls: ['./aceitar-acordo-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
  ],
})
export class AceitarAcordoDialogComponent extends RedeEspecialAcordoDialogBase<AceitarAcordoDialogComponent> {
  constructor(
    public override dialogRef: MatDialogRef<AceitarAcordoDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    override acordosSelecionados: AcordoRedeEspecialViewModel[],
    service: RedeEspecialService,
    snackBar: SnackBarService,
  ) {
    super(dialogRef, acordosSelecionados ?? [], service, snackBar);
  }

  onConfirmar(): void {
    this.loading = true;
    const payload = {
      listaAcordos: this.mapAcordosParaLista(),
      dscUsuario: this.usuarioLogin,
      tipoAtualizacao: TipoAtualizacaoEnum.APROVAR,
    };
    this.service.aprovarOuRejeitarAcordos(payload).subscribe({
      next: () => {
        this.snackBar.flashMessage(
          'Acordo(s) aprovado(s) com sucesso!',
          ['snackbar-success'],
          'Fechar',
          2,
        );
        this.dialogRef.close(true);
      },
      error: () => {
        this.snackBar.flashMessage(
          'Erro ao aprovar acordos!',
          ['snackbar-error'],
          'Fechar',
          2,
        );
        this.dialogRef.close(false);
      },
      complete: () => (this.loading = false),
    });
  }
}
